import { danger } from './toasts/danger';
import { success } from './toasts/success';
export const toast = {
    danger: (message, testId, options) => danger(message, testId, options),
    success: (message, testId, options) => success(message, testId, options),
};
